import { api } from "../api";
import { DRIVER_ALERTS_ENABLED } from "../../../consts/runtimeConfig";
import { DriverAlertCustomerSummaryType } from "../../../types/types";

const findAllDriverAlerts = async (
    token: string,
    customerId: number,
    departmentId?: number
) => {
    if (!DRIVER_ALERTS_ENABLED) {
        const data: DriverAlertCustomerSummaryType = {
            customerId,
            total: 0,
            critical: 0,
            warning: 0,
            alerts: [],
        };
        return { data };
    }

    return api.get<DriverAlertCustomerSummaryType>(`/driver-alerts/customer/${customerId}`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
        params: departmentId && departmentId > -1 ? { departmentId } : undefined,
    });
};

export default findAllDriverAlerts;
